export function CustomSortArray(listUser){
    const ownerList = listUser?.filter(user => user.role === "owner");
    const hostList = listUser?.filter(user => user.role === "host");
    const coHostList = listUser?.filter(user => user.role === "coHost");
    const participantList = listUser?.filter(user => user.role === "participant");
    const sortedArray = [...ownerList, ...hostList, ...coHostList, ...participantList];

    return sortedArray;
}

export function CustomSortJoinedPart(listUser){
    const ownerList = listUser.filter(user => user.participantType === "owner");
    const participantList = listUser.filter(user => user.participantType !== "owner");
    return [...ownerList, ...participantList];
}